/* ラジオボタン */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
var RadioButton = function (_a) {
    var id = _a.id, label = _a.label, need = _a.need, sources = _a.sources, name = _a.name, value = _a.value, handleChange = _a.handleChange, message = _a.message, help_msg = _a.help_msg, disabled = _a.disabled, handleBlur = _a.handleBlur;
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: React.createElement(React.Fragment, null,
            React.createElement(InputGroup, null, sources.map(function (src) {
                return (React.createElement("label", { className: "radio-label", key: src.key },
                    React.createElement(Form.Check, { id: id, type: "radio", inline: true, value: src.key, name: name, checked: src.key === value, onChange: handleChange, disabled: disabled, onBlur: handleBlur, className: "radio-button" }),
                    src.value));
            })),
            disabled || React.createElement(Messages, { help_msg: help_msg, valid_msg: message })) }));
};
export default RadioButton;
